import React from "react";
import {pageAuthorizedByGroup} from "../../fragments/PageAuthorization";
import {formatDateTimeShort, GlobalState} from "../../../global/GlobalState";
import {Link} from "react-router-dom";
import {Breadcrumbs, Button, Paper, Typography} from "@mui/material";
import {textColumn, tooltipColumn} from "../../../components/common/grid/Columns";
import {GraphQlDataGrid} from "../../../components/common/grid/GraphQlDataGrid";
import {graphQLServices} from "../../../services/GraphQLServices";
import {GET_FORMS_OVERVIEW} from "./Queries";
import {PentaSplit} from "../../../components/common/PentaSplit";
import {translateFunction} from "../../../localization/TranslationService";
import {dynamicFormsDefaultTargetStage} from "../DynamicFormsOverviewPage";
import {HeaderSlot, StageSwitch} from "../../../components/onsite/Footer";
import {GridColDef} from "@mui/x-data-grid";

const translate = translateFunction("SureBasePortalDynamicForms");

function DynamicFormsFormsOverview() {
	const columns: GridColDef[] = [
		{
			field: "",
			headerName: translate("Link"),
			renderCell: (params) => (
				<Link to={`./${encodeURIComponent(params.row.formName)}`} style={{
					textDecoration: "initial"
				}}>
					<Button
						variant="contained"
						size="small"
						tabIndex={-1}
					>{translate("Open")}</Button>
				</Link>
			),
			sortable: false,
			editable: false,
			disableColumnMenu: false,
			filterable: false,
		},
		{
			field: "formName",
			headerName: translate("Definition"),
			minWidth: 330,
			renderCell: tooltipColumn(textColumn()),
			flex: 1,
		},
		{
			field: "clientId",
			headerName: translate("Client Name"),
			minWidth: 150,
			renderCell: tooltipColumn(textColumn()),
			flex: 1,
		},
		{
			field: "frontEndName",
			headerName: translate("Front-End Name"),
			minWidth: 150,
			renderCell: tooltipColumn(textColumn()),
			flex: 1,
		},
		{
			field: "lastModifiedBy",
			headerName: translate("Last Modified By"),
			minWidth: 150,
			renderCell: tooltipColumn(textColumn()),
			flex: 1,
		},
		{
			field: "lastModifiedDateTime",
			headerName: translate("Last Modified Date/Time"),
			type: "dateTime",
			minWidth: 220,
			renderCell: tooltipColumn(textColumn()),
			valueFormatter: (params) => formatDateTimeShort(params.value),
			flex: 1,
		}
	];
	
	return <>
		<HeaderSlot><StageSwitch defaultTargetStage={dynamicFormsDefaultTargetStage}/></HeaderSlot>
		<PentaSplit
			top={<Breadcrumbs style={{margin: "5px"}}>
				<Link style={{color: "inherit", textDecoration: "unset"}} to="/dynamicforms">Dynamic Forms</Link>
				<Typography color="text.primary">Forms</Typography>
			</Breadcrumbs>}
			center={<Paper style={{
				height: "100%",
			}}>
				<GraphQlDataGrid
					rows={[]}
					query={GET_FORMS_OVERVIEW}
					graphFunction={"formSetups"}
					client={graphQLServices.dynamicFormsClient}
					rowsPerPageOptions={[50, 100]}
					initialPageSize={50}
					columns={columns}
					getRowId={row => row.formId}
					defaultSortModel={[
						{
							field: "formName",
							sort: "asc"
						}
					]}
					queryVariables={{
						stage: GlobalState.targetKiziStage(dynamicFormsDefaultTargetStage)
					}}
					// todo add button
					// slots={{
					// 	footer: CustomFooter
					// }}
				/>
			</Paper>}
		/>
	</>;
}

export const DynamicFormsFormsOverviewPage = pageAuthorizedByGroup(DynamicFormsFormsOverview, ["Admin", "DynamicForms"]);
